import ServiceGraphQL from 'src/service/gql-service';
import { updateIndividual } from 'src/graphql';
import { CreateIndividual } from './createIndividual';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const UpdateIndividual = (data, _id) => {
  const params = {
    query: updateIndividual.QUERY,
    variables: {
      record: data,
      filter: {
        _id
      }
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.individualUpdateOne;
    })
    .catch((err) => {
      throw err;
    });
};

export const UpsertIndividual = (data, _id) => {
  if (_id) {
    return UpdateIndividual(data, _id);
  } else {
    return CreateIndividual(data);
  }
};
